export type TPages = 'WHATS_NEW' | 'SEARCH' | 'MY_COMMUNITIES' | 'DISCOVER_COMMUNITIES' | 'MY_NETWORK_ACTIVITY' | 'MY_BOOKMARKS' | 'MY_SUGGESTIONS' | 'MANAGEMENT'

export type IStaticPaths = Record<string, TPages>
export type IStaticPageNames = Record<TPages, string>

export const Static_Paths: IStaticPaths = {
  '/home': 'WHATS_NEW',
  '/search': 'SEARCH',
  '/my-communities': 'MY_COMMUNITIES',
  '/discover-communities': 'DISCOVER_COMMUNITIES',
  '/my-network-activity': 'MY_NETWORK_ACTIVITY',
  '/my-bookmarks': 'MY_BOOKMARKS',
  '/my-suggestions': 'MY_SUGGESTIONS',
  '/tenant-admin': 'MANAGEMENT',
}

export const Static_Page_Names: IStaticPageNames = {
  WHATS_NEW: 'What\'s New',
  SEARCH: 'Search',
  MY_COMMUNITIES: 'My Communities',
  DISCOVER_COMMUNITIES: 'Discover Communities',
  MY_NETWORK_ACTIVITY: 'My Network Activity',
  MY_BOOKMARKS: 'My Bookmarks',
  MY_SUGGESTIONS: 'My Suggestions',
  MANAGEMENT: 'Management',
}

export const Conversation_Page_Regex = /^\/dm\/[A-Za-z0-9-_]+/
export const Community_Page_Regex = /^\/community\/[A-Za-z0-9-_]+/
export const Profile_Page_Regex = /^\/profile\//
export const Rituals_Page_Regex = /^\/rituals\//
export const User_Profile_Page_Regex = (login: string) => new RegExp(`^\/profile\/${login}`)

export const Conversation_Page_Name = 'Conversations'
export const Rituals_Page_Name = 'Rituals'
export const Profile_Page_Name = 'Profile'
export const My_Profile_Page_Name = 'My Profile'
